import _ from 'lodash';

export default new (class Spinner {
	constructor() {
		this.className = 'spinner-on';
		this._clicked = [];
	}

	handleClick(element) {
		angular.element(element).addClass(this.className);
		let uid = _.uniqueId('click-');
		this._clicked.push({ element, uid });
	}

	handleAjaxRequest(config) {
		if (this._clicked.length === 0) {
			return;
		}
		config.spinnerUid = this._clicked[0].uid;
	}

	handleAjaxResponse(response) {
		if (this._clicked.length === 0 || !response.config.spinnerUid) {
			return;
		}
		this._clicked = this._clicked.filter(click => {
			if (click.uid == response.config.spinnerUid) {
				angular.element(click.element).removeClass(this.className);
				return false;
			}
			return true;
		});
	}

	stopAll() {
		this._clicked.forEach(click => {
			angular.element(click.element).removeClass(this.className);
		});
		this._clicked.length = 0;
	}
})();
